import React, { Component } from 'react'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { getCategories, getSubcategories, getSubjects } from '../../Quiz/actions';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import SelectFieldAnt from '../../helpers/Fields/SelectFieldAnt';
import { connect } from 'react-redux';

class ModalImport extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      categories: [],
      subcategories: [],
      subjects: [],
    }
  }


  async componentDidMount(){
    const [categories, subcategories, subjects] = await Promise.all([
      getCategories(),
      getSubcategories(),
      getSubjects(),
    ]);

    this.setState({
      categories,
      subcategories,
      subjects,
      loaded: true
    });
  }

  handleClose = () => {
    this.props.onClose()
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex, handleSubmit, subject_id, category_id, isOpen } = this.props;

    const {subjects, categories, subcategories,} = this.state;
    
    const subject_opt = subjects.filter(_i => _i.status == 1).map(_i => ({title: _i.name, value: _i.id}));
    const categories_opt = categories.filter(_i => _i.status == 1 && _i.branch_id == subject_id).map(_i => ({title: _i.name, value: _i.id}));
    const subcategories_opt = subcategories.filter(_i => _i.status == 1 && _i.category_id == category_id).map(_i => ({title: _i.name, value: _i.id}));
    return (
      <Modal
          isOpen = {isOpen}
          style = {{
              overlay : {zIndex: 999999},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              <div className="create-dialog-modal-content__title">{formatMessage('importModalTitle')}</div>
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
          <form className="create-dialog-form" onSubmit={handleSubmit(this.props.importSelectedItem)}>
              {/* <div className="row mb-5">
                <div className="col-xs-12 text-center word-wrap-break">
                  {formatMessage('frmMessageRecoveryQuestion')}
                </div>
              </div> */}
              <div className="row mb-5">
                <Field
                  name='subject_id'
                  label={formatMessage('txtCaptionSubject')}
                  component={SelectFieldAnt}
                  validate={[required()]}
                  options={subject_opt}
                  onChange={(value) => {
                    this.props.change('subject_id', value);
                    this.props.change('category_id', '');
                    this.props.change('subcategory_id', '');
                  }}
                />
                <Field 
                  name='category_id'
                  label={formatMessage('txtCaptionCategory')}
                  component={SelectFieldAnt}
                  validate={[required()]}
                  options={categories_opt}
                  onChange={(value) => {
                    this.props.change('category_id', value);
                    this.props.change('subcategory_id', '');
                  }}
                />
                <Field 
                  name='subcategory_id'
                  label={formatMessage('txtCaptionSubjategory')}
                  component={SelectFieldAnt}
                  options={subcategories_opt}
                />
              </div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-primary mr-auto" type="submit">{formatMessage('btnModalSendImport')}</button>
                <button className="btn btn-warning" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancel')}</button>
              </div>
            </form>
          </div>
      </Modal>
    )
  }
}


ModalImport = reduxForm({
  form: 'import_question',
  enableReinitialize: true,
})(ModalImport);


const selector = formValueSelector('import_question')

const mapStateToProps = (state, ownProps) => ({
  subject_id: selector(state, 'subject_id'),
  category_id: selector(state, 'category_id')
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalImport)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionImport/components/ModalImport.jsx